import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

const styles = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 },
  h1: { fontSize: 22, fontWeight: 600 },
  btn: {
    padding: '8px 16px', backgroundColor: '#4a9eff', color: '#fff',
    border: 'none', borderRadius: 4, fontSize: 13, fontWeight: 600, cursor: 'pointer',
  },
  btnDanger: {
    padding: '6px 12px', backgroundColor: '#fff', color: '#e74c3c',
    border: '1px solid #e74c3c', borderRadius: 4, fontSize: 12, cursor: 'pointer',
  },
  btnSuccess: {
    padding: '6px 12px', backgroundColor: '#fff', color: '#27ae60',
    border: '1px solid #27ae60', borderRadius: 4, fontSize: 12, cursor: 'pointer',
  },
  table: { width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff', borderRadius: 8, overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' },
  th: { textAlign: 'left', padding: '10px 14px', backgroundColor: '#f8f9fa', fontSize: 12, fontWeight: 600, color: '#666', textTransform: 'uppercase', borderBottom: '1px solid #eee' },
  td: { padding: '10px 14px', borderBottom: '1px solid #f0f0f0', fontSize: 14 },
  link: { color: '#4a9eff', textDecoration: 'none', fontWeight: 500 },
  badge: (active) => ({
    display: 'inline-block', padding: '2px 8px', borderRadius: 10, fontSize: 12, fontWeight: 500,
    backgroundColor: active ? '#e6f9e6' : '#f0f0f0',
    color: active ? '#27ae60' : '#999',
  }),
  modal: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.4)', display: 'flex',
    alignItems: 'center', justifyContent: 'center', zIndex: 1000,
  },
  modalCard: {
    backgroundColor: '#fff', borderRadius: 8, padding: 24, width: 420,
    boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
  },
  modalTitle: { fontSize: 18, fontWeight: 600, marginBottom: 16 },
  label: { display: 'block', fontSize: 13, fontWeight: 500, color: '#555', marginBottom: 4 },
  input: { width: '100%', padding: '8px 10px', border: '1px solid #ddd', borderRadius: 4, fontSize: 14, marginBottom: 12 },
  select: { width: '100%', padding: '8px 10px', border: '1px solid #ddd', borderRadius: 4, fontSize: 14, marginBottom: 12 },
  btnRow: { display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 },
  btnCancel: { padding: '8px 16px', backgroundColor: '#f0f0f0', border: 'none', borderRadius: 4, fontSize: 13, cursor: 'pointer' },
};

const FREQ_OPTIONS = [
  { value: 'weekly', label: 'Weekly' },
  { value: 'fortnightly', label: 'Fortnightly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
];

export default function Titles() {
  const [titles, setTitles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ name: '', frequency: 'weekly', edition_day: 1, renewal_lead_days: 28 });

  const load = () => {
    api.getTitles().then(setTitles).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handleSave = async () => {
    if (!form.name.trim()) return;
    await api.createTitle(form);
    setShowModal(false);
    setForm({ name: '', frequency: 'weekly', edition_day: 1, renewal_lead_days: 28 });
    load();
  };

  const handleDeactivate = async (id, name) => {
    if (!window.confirm(`Deactivate "${name}"? It will be hidden but not deleted.`)) return;
    await api.deleteTitle(id);
    load();
  };

  const handleReactivate = async (id, name) => {
    if (!window.confirm(`Reactivate "${name}"?`)) return;
    await api.updateTitle(id, { active: true });
    load();
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <div style={styles.header}>
        <h1 style={styles.h1}>Titles</h1>
        <button style={styles.btn} onClick={() => setShowModal(true)}>+ Add Title</button>
      </div>

      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Title</th>
            <th style={styles.th}>Frequency</th>
            <th style={styles.th}>Active Subscribers</th>
            <th style={styles.th}>Renewal Lead</th>
            <th style={styles.th}>Status</th>
            <th style={styles.th}></th>
          </tr>
        </thead>
        <tbody>
          {titles.map(t => (
            <tr key={t.id} style={t.active ? {} : { opacity: 0.55 }}>
              <td style={styles.td}>
                <Link to={`/titles/${t.id}`} style={styles.link}>{t.name}</Link>
              </td>
              <td style={styles.td}>{t.frequency}</td>
              <td style={styles.td}>{t.active_subscribers}</td>
              <td style={styles.td}>{t.renewal_lead_days} days</td>
              <td style={styles.td}><span style={styles.badge(t.active)}>{t.active ? 'Active' : 'Inactive'}</span></td>
              <td style={styles.td}>
                {t.active ? (
                  <button style={styles.btnDanger} onClick={() => handleDeactivate(t.id, t.name)}>Deactivate</button>
                ) : (
                  <button style={styles.btnSuccess} onClick={() => handleReactivate(t.id, t.name)}>Reactivate</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showModal && (
        <div style={styles.modal} onClick={() => setShowModal(false)}>
          <div style={styles.modalCard} onClick={e => e.stopPropagation()}>
            <div style={styles.modalTitle}>Add Title</div>
            <label style={styles.label}>Title Name</label>
            <input style={styles.input} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} autoFocus />
            <label style={styles.label}>Frequency</label>
            <select style={styles.select} value={form.frequency} onChange={e => setForm({ ...form, frequency: e.target.value })}>
              {FREQ_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
            <label style={styles.label}>Edition Day (0=Sun for weekly, 1-31 for monthly)</label>
            <input style={styles.input} type="number" value={form.edition_day} onChange={e => setForm({ ...form, edition_day: parseInt(e.target.value) || 1 })} />
            <label style={styles.label}>Renewal Lead Time (days before expiry)</label>
            <input style={styles.input} type="number" value={form.renewal_lead_days} onChange={e => setForm({ ...form, renewal_lead_days: parseInt(e.target.value) || 28 })} />
            <div style={styles.btnRow}>
              <button style={styles.btnCancel} onClick={() => setShowModal(false)}>Cancel</button>
              <button style={styles.btn} onClick={handleSave}>Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
